import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en_common from "./locales/en/common.json";
import no_common from "./locales/no/common.json";
import de_common from "./locales/de/common.json";

const resources: Resource = {
  en: { common: en_common },
  no: { common: no_common },
  de: { common: de_common },
};

// i18next takes the first exact match in the browser's list, and browsers name
// languages with a region (de-DE, en-GB) and Norwegian as nb (bokmål) or nn
// (nynorsk). So ["nb-NO", "en-US"] gave English. Reduced to the language alone,
// with nb and nn as "no", the browser's first language wins.
export function baseLanguage(language: string) {
  const base = language.split(/[-_]/)[0].toLowerCase();
  return base === "nb" || base === "nn" ? "no" : base;
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "no",
    supportedLngs: ["no", "en", "de"],
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: { convertDetectedLanguage: baseLanguage },
  });

export function currencyFromLanguage(language: string) {
  switch (language) {
    case "no":
      return "nok";
    case "en":
      return "usd";
    case "de":
      return "eur";
    default:
      return "nok";
  }
}

export default i18n;
